import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { QuickInfoComponent } from './quick-info.component';
import { MatTooltipModule } from '@angular/material/tooltip';
import { TruncateModule } from 'app/pipes/truncate/truncate-pipe.module';
import { MatIconModule } from '@angular/material/icon';



@NgModule({
  declarations: [
    QuickInfoComponent
  ],
  imports: [
    CommonModule,
    MatTooltipModule,
    TruncateModule,
    MatIconModule
  ],
  exports: [
    QuickInfoComponent
  ]
})
export class QuickInfoModule { }
